/**
 * Host-basiertes White-Label für alle Seiten, die VOR dem Login gerendert
 * werden (Login, Forgot/Reset Password, Verify Email, Register, …).
 *
 * Motivation: Diese Seiten haben noch keinen User und damit kein `orgType`,
 * also kann das normale orgType-basierte Whitelabel (Header, Footer,
 * KiZentrale-Tabs) hier nicht greifen. Stattdessen erkennen wir den
 * White-Label-Host am `window.location.hostname` und überblenden alle
 * WerkPilot-Branding-Elemente mit den des Partners.
 *
 * Erweiterung um weitere Hosts: Hier einen zusätzlichen Eintrag in der
 * Lookup-Tabelle ergänzen. Für dynamische Konfig (z.B. per API pro Host)
 * wäre ein kleiner `GET /api/public/branding?host=…` Endpoint sauberer,
 * für jetzt reicht die statische Tabelle.
 */

const HEYKIKI_BRANDING = {
  name:       'HeyKiki',
  subtitle:   'Kunden-Portal',
  accent:     '#81c264',
  accentDark: '#67a846',
  logo:       '/heykiki-logo.png',
  fontFamily: "'Montserrat', sans-serif",
  // Passwort-Flows: HeyKiki verwaltet Passwörter selbst, unser /forgot-password
  // und /register funktionieren daher nicht. Stattdessen Hinweis anzeigen.
  passwordFlowHandledExternally: true,
  supportContact: 'HeyKiki'
};

const HOST_BRANDINGS = {
  heykiki:  HEYKIKI_BRANDING,
  kikichat: HEYKIKI_BRANDING
};

export function getHostBranding() {
  if (typeof window === 'undefined') return null;
  const host = window.location.hostname.toLowerCase();
  for (const [marker, branding] of Object.entries(HOST_BRANDINGS)) {
    if (host.includes(marker)) return branding;
  }
  return null;
}

/**
 * Setzt die Theme-Color und den Document-Title für Whitelabel-Hosts.
 * Liefert die Cleanup-Funktion zurück, die das Original wiederherstellt.
 * Als useEffect-Body verwenden:
 *
 *   useEffect(() => applyHostBrandingMeta(hostBranding, 'Login'), [hostBranding]);
 */
export function applyHostBrandingMeta(hostBranding, pageTitle = '') {
  const metaThemeColor = document.querySelector('meta[name="theme-color"]');
  const originalColor = metaThemeColor?.getAttribute('content');
  const originalTitle = document.title;

  const themeColor = hostBranding?.accent || '#378ab2';
  if (metaThemeColor) metaThemeColor.setAttribute('content', themeColor);

  if (hostBranding) {
    document.title = pageTitle
      ? `${hostBranding.name} – ${pageTitle}`
      : hostBranding.name;
  }

  return () => {
    if (metaThemeColor && originalColor) {
      metaThemeColor.setAttribute('content', originalColor);
    }
    if (hostBranding) document.title = originalTitle;
  };
}
